import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import ShopTab from "./ShopTab";
import LOG, { log } from "../../../UTIL/LOG";
import ShopItem from "./ShopItem";
import GameInstance from "../GameInstance";

class Shop
{
    public conquer          : CONQUER;
    public tabs             : any;
    private vars            : any = {};
    public items            : any;
    public inventory        : any;
    private gameInstance    : GameInstance;

    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
        
    }

    public init( data:any )
    {
        this.vars           = { gameID:this.gameInstance.gameID };

      //  log("INIT SHOP", data );
        this.processData( data )
    }

    public async set( shopTabs:any ) : Promise<any> // Deprecated for now
    {
 
    }

    public async setShop( shop:any ) : Promise<any>
    {
        let results : any = await this.conquer.do( ACTIONS.GAME_SHOP_SET, { gameID:this.vars.gameID, shop:shop } );
 
        return Promise.resolve( this.processData( results ) );
    }
 
    public async get( force?:boolean ) : Promise<any>
    {
        if( !force && this.tabs ) return Promise.resolve( this );
 
        for( let n in this.items ) this.items[n].stop();

        let results : any = await this.conquer.do( ACTIONS.GAME_SHOP_GET, this.vars );
 
        return Promise.resolve( this.processData( results ) );
    }
    
    public find( keysArray:Array<string> )
    {
        let output = [];

        for( let n in keysArray ) 
        {
            let shopItem = this.items[ keysArray[n] ];
            if( shopItem ) output.push( shopItem );
        }

        return output;
    }

    private processData( shopData : any )
    {
        this.tabs       = {};
        this.items      = {};
        this.inventory  = [];
 
        for( let key in shopData )
        {
            let tab = shopData[ key ];
            new ShopTab( this, tab );
            for( let n in tab.items ) new ShopItem( this.gameInstance, tab.items[ n ] );
        }

        for( let key in this.tabs ) this.tabs[ key ].sort();
 
        return shopData;
    }
}

export default Shop;